var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.423 2.07812H12.4229C9.9033 2.07812 7.48693 3.07902 5.70534 4.86061C3.92374 6.64221 2.92285 9.05857 2.92285 11.5781V106.578C2.92285 109.098 3.92374 111.514 5.70534 113.296C7.48693 115.077 9.9033 116.078 12.4229 116.078H107.423C109.942 116.078 112.359 115.077 114.14 113.296C115.922 111.514 116.923 109.098 116.923 106.578V11.5781C116.923 9.05857 115.922 6.64221 114.14 4.86061C112.359 3.07902 109.942 2.07812 107.423 2.07812Z",
    stroke: "#EBEBEB",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2568 30.5781L28.2568 87.5781M85.2568 87.5781V62.2448M85.2568 46.4115V43.2448M47.2568 30.5781L66.2568 87.5781M34.5902 68.5781H59.9235",
    stroke: "#EBEBEB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory13);
export default __webpack_public_path__ + "static/media/category-13.5fddf73780cfea66801bde01ec186b4f.svg";
export { ForwardRef as ReactComponent };